import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { addDocument, updateDocument, getDocument } from './firestore';
import { FaChevronLeft, FaChevronRight, FaGamepad, FaInfoCircle, FaArrowLeft, FaPlay } from 'react-icons/fa';

// Remove CSS import as we'll use Tailwind
// import './Instructions.css';

function Instructions() {
  const auth = getAuth();
  const { gameId } = useParams();
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, []);

  // Game data stays the same

  const gamesData = {
    '2048': {
      instructions: [
        'Combine tiles to create the "2048" tile.',
        'Starting: The game starts with two random tiles, "2" or "4", on a 4x4 grid.',
        'Move Tiles: Use arrow keys (up, down, left, right) to slide all tiles in that direction.',
        'Combine Tiles: When two tiles with the same number collide, they merge into one with their total (e.g., two "2"s become a "4").',
        'New Tile: After each move, a new "2" or "4" appears on the board.',
        'Win or Lose: You win by creating a "2048" tile. You lose if the grid fills up with no more moves left.'
      ],
      images: [
        '/GamePreview/2048-1.jpg',
        '/GamePreview/2048-2.jpg'
      ],
      route: '/2048',
    },
    'bricks-mania': {
      instructions: [
        'Move the Paddle: Use the arrow keys to control the movement of the paddle left and right.',
        'Break the Blocks: Bounce the ball off the paddle to hit and destroy the blocks above.',
        'Do Not Miss the Ball: Always catch the ball with your paddle. Missing the ball will cost you a life, and losing all lives ends the game.',
        'Level Up: Clear all the blocks to advance to the next level. With each new level, the ball moves faster, increasing the challenge.',
        'Score Points: Earn points for every block you break. Keep playing to maximize your score!'
      ],
      images: [
        '/GamePreview/BM-1.jpg',
        '/GamePreview/BM-2.jpg',
      ],
      route: '/brickmania',
    },
    'sodoku': {
      instructions: [
        'Fill the Grid: Place numbers 1-9 in each row, column, and 3x3 box without repeating.',
        'No Duplicates: Ensure no number repeats in any row, column, or 3x3 box.',
        'Complete the Puzzle: Fill all the empty spaces following the rules to solve the Sudoku!',
      ],
      images: [
        '/path/to/flappy-bird-preview-1.png',
        '/path/to/flappy-bird-preview-2.png',
        '/path/to/flappy-bird-preview-3.png'
      ],
      route: '/sodoku',
    },
    'snake': {
      instructions: [
        'Move the Snake: Use the arrow keys to move the snake up, down, left, and right.',
        'Eat the Food: Guide the snake to the food to make it grow longer and earn points.',
        'Avoid Collisions: Don not let the snake run into itself or it will end the game.',
        'Stay Alive: The longer you survive, the higher your score. As the game progresses, the snake moves faster, increasing the challenge.'
      ],
      images: [
        '/GamePreview/Snake-1.jpg',
        '/GamePreview/Snake-2.jpg'
      ], route: '/snake',
    },
    'word-search': {
      instructions: [
        'Find Words: Look for the listed words hidden in the grid. Words can be arranged horizontally, vertically, or diagonally, and may be forwards or backwards.',
        'Click the Letters: Once you spot a word, click on its letters in the correct order to mark it as found.',
        'Reset Selection (If Needed): If you click the wrong letter, do not worry! Click the "Reset Selection" button to clear your current selection and try again.',
        'Complete the List: Keep searching until you have found all the words on the list to complete the puzzle.',
        'Boost Your Score: Finding words in quick succession increases your score multiplier. The faster you complete the puzzle, the higher your total score will be!'
      ],
      images: [
        '/GamePreview/wordSearch1.png',
        '/GamePreview/wordSearch2.png',
        '/GamePreview/wordSearch3.png'
      ],
      route: '/wordsearch',
    },
    'whack-a-mole': {
      instructions: [
        'Watch the Moles: Moles will pop up randomly from the holes in the game board. Stay alert and be ready!',
        'Hit the Moles: Click on the moles as quickly as possible before they disappear. Be precise to maximize your score!',
        'Score Points: Each mole you hit successfully earns you points. Hit as many moles as you can to achieve a high score.',
        'Answer Questions: Periodically, quiz questions will appear. Answer them correctly to earn bonus points.',
        'Time Limit: You have 60 seconds to score as many points as possible. The game ends when the timer runs out.',
      ],
      images: [
        '/GamePreview/Mole-1.jpg',
        '/GamePreview/Mole-2.jpg'
      ],
      route: '/whack',
    },
    'tetris': {
      instructions: [
        'Blocks appear: Colored blocks of different shapes will appear at the top of the grid.',
        'Move and rotate: Use the arrow keys to move the block left, right, or down. Use the up arrow key to rotate the block.',
        'Place the block: When you are ready, press the spacebar to place the block on the grid.',
        'Clear lines: If a row of squares is filled horizontally, it will disappear, and the squares above it will fall down. This clears the line.',
        'Try to avoid letting blocks stack up to the top of the grid. If the blocks reach the top, the game is over.'
      ],
      images: [
        '/GamePreview/Tetris-1.jpg',
        '/GamePreview/Tetris-2.jpg'
      ],
      route: '/tetris',
    },
    'shooter': {
      instructions: [
        'Control Your Rocket: Use the arrow keys to move your rocket and dodge incoming meteors.',
        'Shoot Meteors: Aim precisely and fire using the spacebar to destroy meteors before they crash into Earth or hit your rocket.',
        'Stay Alert: Avoid letting meteors pass you or collide with your rocket. If they do, the game will end.',
        'Control your rocket and aim precisely',
        'Score points by shooting down meteors and answer quiz questions to boost your score!',
        'Brace for Speed: Meteors will get faster as the game progresses, so stay sharp and adjust your strategy.'
      ],
      images: [
        '/GamePreview/MB-1.jpg',
        '/GamePreview/MB-2.jpg'      
      ],
      route: '/shooter',
    },
    'word-scramble': {
      instructions: [
        'Look at the Scrambled Word: A scrambled word will appear with its letters all mixed up.',
        'Unscramble the Word: Rearrange the letters in your mind to figure out the correct word.',
        'Type Your Answer: Once you think you know the word, type it into the answer box and submit.The faster you answer, the more points you earn!',
        'Manage Your Hearts: Answer questions correctly to keep playing. Each wrong answer costs you one heart. The game ends when you lose all your hearts.',
        'Watch Your Hearts: Manage your remaining hearts carefully to stay in the game as long as possible.'
      ],
      images: [
        '/GamePreview/wordScramble1.jpg',
        '/GamePreview/wordScramble2.jpg',
        '/GamePreview/wordScramble3.jpg'
      ],
      route: '/word-scramble',
    },
    'mario': {
      instructions: [
        'Press "Enter" to start the game.',
        'Use the arrow keys to move Mario around the obstacles.',
        'Collect coins and avoid enemies to score points.',
        'Press "Space" to jump.'
      ],
      images: [
        '/GamePreview/mario1.png',
        '/GamePreview/mario2.png',
        '/GamePreview/mario3.png'
      ],
      route: '/mario',
    },
    'matching': {
      instructions: [
        'Select a Question: From the question bank, choose a question to match. Each question will test your knowledge, so read carefully!',
        'Match the question to the correct answer in the answer bank.',
        'Score Points: Each correct match earns you points, helping you climb the leaderboard. Wrong Matches: If you pick the wrong answer, you may lose a life. Be strategic with your choices!',
        'Complete all matches before running out of lives to win the game.',
        'Be quick and accurate to maximize your score!'
      ],
      images: [
        '/GamePreview/Match-2.jpg',
        '/GamePreview/Match-1.jpg',
      ],
      route: '/matching',
    },

    // Add more games here...
  };

  const game = gamesData[gameId];

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex === 0 ? game.images.length - 1 : prevIndex - 1));
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex === game.images.length - 1 ? 0 : prevIndex + 1));
  };

  const handleClose = () => {
    navigate('/games');
  };

  const handleOpen = async () => {
    if (game && game.route) {
      var gameplay_id = await firestoreGameplay(gameId);
      let gameRoute = game.route + '?id=' + gameplay_id;
      navigate(gameRoute);
    } else {
      console.log("Game route not found");
    }
  };

  // Firebase functions remain the same
  const firestoreGameplay = async (gameId) => {
    try {
      const userId = auth.currentUser.uid;
      const subCollectionPath = `gameplay/${userId}/gameplays`;
  
      const gameplayId = crypto.randomUUID(); 
  
      const gameplayData = {
        uid: userId,
        game_id: gameId,
        total_questions: 0,
        questions_answered: 0,
        score: 0,
        lives: 3,
        played_at: new Date().toUTCString()
      };
      
      await addDocument(subCollectionPath, gameplayId, gameplayData);
      await updateUserStreak();
      console.log("New Gameplay uploaded!");   
      return gameplayId;
    } catch (e) {
      console.error("Error adding gameplay document: ", e);
    }
  };

  async function updateUserStreak() {
    const userId = auth.currentUser.uid;

    const userDocPath = `users`;
    const userData = await getDocument(userDocPath, userId);
    const lastStreakUpdated = userData.streak_updated ? userData.streak_updated : null;
    const currentStreak = userData.streak || 0;
    
    const currentDate = new Date();
    let updatedStreak = 1;
    
    if (lastStreakUpdated) {    
      const diffTime = Math.abs(currentDate - new Date(lastStreakUpdated));

      const timeDifference = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 
      if (timeDifference === 1) {
        updatedStreak = currentStreak + 1;
      } else if (timeDifference >= 2) {
        updatedStreak = 1;
      } else {
        updatedStreak = currentStreak; 
      }
    } else {
      updatedStreak = 1; 
    }

    const updatedData = {
      streak: updatedStreak,
      streak_updated: new Date(),
    };

    await updateDocument(userDocPath, userId, updatedData);
  }

  if (!game) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--background-color)]">
        <div className="text-center p-8 bg-[var(--surface-color)] rounded-lg shadow-lg">
          <FaGamepad className="text-5xl text-[var(--interactive-color)] mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-[var(--text-color)]">Game Not Found</h2>
          <p className="text-[var(--secondary-color)] mt-2 mb-6">Sorry, we couldn't find this game.</p>
          <button 
            onClick={() => navigate('/games')}
            className="px-6 py-2 bg-[var(--interactive-color)] text-white rounded-lg hover:bg-opacity-90 transition-all"
          >
            Back to Games
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[var(--background-color)] py-8 px-4 sm:px-6 lg:px-8 animate-fadeIn">
      <div className="max-w-7xl mx-auto">
        {/* Back Button */}
        <button 
          onClick={handleClose}
          className="flex items-center text-[var(--interactive-color)] mb-6 hover:underline focus:outline-none focus:ring-2 focus:ring-[var(--interactive-color)] rounded-md"
        >
          <FaArrowLeft className="mr-2" />
          <span>Back to Games</span>
        </button>
        
        {/* Game Title with Gradient */}
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-10 bg-gradient-to-r from-[var(--primary-color)] via-[var(--interactive-color)] to-[var(--accent-color)] text-transparent bg-clip-text transform transition-all">
          {gameId.replace('-', ' ').toUpperCase()}
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10">
          {/* How to Play Section */}
          <div className="bg-[var(--surface-color)] rounded-2xl shadow-lg overflow-hidden border border-[var(--border-color)]">
            <div className="bg-[var(--primary-color)] py-4 px-6">
              <div className="flex items-center">
                <FaInfoCircle className="text-white text-xl mr-3" />
                <h2 className="text-2xl font-bold text-white">How To Play</h2>
              </div>
            </div>
            
            <div className="p-6">
              <ol className="space-y-4 text-left">
                {game.instructions.map((instruction, index) => (
                  <li key={index} className="flex items-start">
                    <span className="flex-shrink-0 flex items-center justify-center w-6 h-6 rounded-full bg-[var(--interactive-color)] text-white text-sm font-bold mr-3">
                      {index + 1}
                    </span>
                    <span className="text-[var(--text-color)]">{instruction}</span>
                  </li>
                ))}
              </ol>
            </div>
          </div>

          {/* Game Preview Section */}
          <div className="bg-[var(--surface-color)] rounded-2xl shadow-lg overflow-hidden border border-[var(--border-color)]">
            <div className="bg-[var(--primary-color)] py-4 px-6">
              <div className="flex items-center">
                <FaGamepad className="text-white text-xl mr-3" />
                <h2 className="text-2xl font-bold text-white">Game Preview</h2>
              </div>
            </div>
            
            <div className="p-6">
              <div className="relative">
                <div className="aspect-w-16 aspect-h-9 bg-[var(--surface-color-hover)] rounded-lg overflow-hidden">
                  <img
                    src={game.images[currentImageIndex]}
                    alt={`${gameId} gameplay preview ${currentImageIndex + 1} of ${game.images.length}`}
                    className="w-full h-full object-contain"
                  />
                </div>
                
                <div className="absolute inset-x-0 top-1/2 transform -translate-y-1/2 flex justify-between px-4">
                  <button 
                    onClick={handlePrevImage}
                    className="w-10 h-10 rounded-full bg-black/50 text-white flex items-center justify-center hover:bg-black/70 transition-colors focus:outline-none focus:ring-2 focus:ring-white"
                    aria-label="Previous image"
                  >
                    <FaChevronLeft />
                  </button>
                  <button 
                    onClick={handleNextImage}
                    className="w-10 h-10 rounded-full bg-black/50 text-white flex items-center justify-center hover:bg-black/70 transition-colors focus:outline-none focus:ring-2 focus:ring-white"
                    aria-label="Next image"
                  >
                    <FaChevronRight />
                  </button>
                </div>
              </div>
              
              {/* Image Counter */}
              <div className="flex justify-center mt-4">
                {game.images.map((_, index) => (
                  <div 
                    key={index} 
                    className={`w-2 h-2 rounded-full mx-1 ${
                      currentImageIndex === index 
                        ? 'bg-[var(--interactive-color)]' 
                        : 'bg-[var(--border-color)]'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Play Button */}
        <div className="flex justify-center">
          <button 
            onClick={handleOpen}
            className="group relative inline-flex items-center px-8 py-4 bg-[var(--success-color)] text-white rounded-lg text-xl font-bold transform transition-all duration-300 hover:bg-opacity-90 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--success-color)] focus:ring-offset-2 focus:ring-offset-[var(--background-color)]"
          >
            <FaPlay className="mr-3 text-white group-hover:animate-pulse" />
            Play Game
          </button>
        </div>
      </div>
    </div>
  );
}

export default Instructions;
